export function getAllowedMinutesBelowThreshold({
  threshold,
  step,
}: {
  threshold: number;
  step: number;
}) {
  let allowedMinutes = 0;
  for (let minutes = 0; minutes <= 60; minutes += step) {
    if (minutes < threshold) {
      allowedMinutes = minutes;
    }
  }

  return allowedMinutes;
}
